// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import _ from "lodash";
import React, { RefObject } from "react";
import { connect } from "react-redux";
//import { RouteComponentProps } from "react-router-dom";
import { RouteComponentProps, Link } from "react-router-dom";
import SplitPane from "react-split-pane";
import { bindActionCreators } from "redux";
import { strings, interpolate } from "../../../../common/strings";
import {
    AssetState, AssetType, EditorMode, FieldType,
    IApplicationState, IAppSettings, IAsset, IAssetMetadata,
    ILabel, IProject, IRegion, ISize, ITag, FeatureCategory, FieldFormat,
    IAuthenticationState, IAzureFields
} from "../../../../models/applicationState";
import IApplicationActions, * as applicationActions from "../../../../redux/actions/applicationActions";
import IProjectActions, * as projectActions from "../../../../redux/actions/projectActions";
import IAppTitleActions, * as appTitleActions from "../../../../redux/actions/appTitleActions";
import { TagInput } from "../../common/tagInputFR/tagInput";
import Canvas from "./canvas";
import "./editorPage.scss";
import Confirm from "../../common/confirm/confirm";
import { Spinner, SpinnerSize } from "@fluentui/react/lib/Spinner";
import BeforeUnloadComponent from "react-beforeunload-component";
import HeaderComponent from "../header/header";
import size from "lodash/size";
import OperationsHeader from "../header/operationsSubHeader";
import IUserOperationsActions, * as userOperationsActions from "../../../../redux/actions/operationsActions";
import JsonResponse from "./jsonResponse";
import { headers, postProcessingEditTags } from "../../../../common/api-config";
import axios from "axios";
import { data } from "@tensorflow/tfjs";
import { ktpTargetFromId } from "@fluentui/react";


/**
 * Properties for Editor Page
 * @member project - Project being edited
 * @member recentProjects - Array of projects recently viewed/edited
 * @member actions - Project actions
 * @member applicationActions - Application setting actions
 */
export interface IEditorPage_Post_ProcessProps extends RouteComponentProps, React.Props<EditorPage_Post_Process> {
    project: IProject;
    recentProjects: IProject[];
    appSettings: IAppSettings;
    actions: IProjectActions;
    applicationActions: IApplicationActions;
    appTitleActions: IAppTitleActions;
    loggedInUser: IAuthenticationState;
    loadAnnotateFiles: IAsset[];
    userOperationsActions: IUserOperationsActions;

}

/**
 * State for Editor Page
 */
export interface IEditorPage_Post_ProcessState {
    /** Array of assets in project */
    assets: IAsset[];
    /** The editor mode to set for canvas tools */
    editorMode: EditorMode;
    /** The selected asset for the primary editing experience */
    selectedAsset?: IAssetMetadata;
    /** Currently selected region on current asset */
    selectedRegions?: IRegion[];
    /** Most recently selected tag */
    selectedTag: string;
    /** Tags locked for region labeling */
    lockedTags: string[];
    /** Size of the asset thumbnails to display in the side bar */
    thumbnailSize: ISize;
   

    userId: string;
    project: IProject;
    tagsInfo: any;
    iseTagSelected: boolean;
    eTagSelectedId: string;
    eTagSelectedVal: string;
    newTagValue: string;
    editClicked:boolean;
}

function mapStateToProps(state: IApplicationState) {
    return {
        recentProjects: state.recentProjects,
        project: state.currentProject,
        appSettings: state.appSettings,
        loggedInUser: state.loggedInUser,
        loadAnnotateFiles: state.loadAllFiles,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(projectActions, dispatch),
        applicationActions: bindActionCreators(applicationActions, dispatch),
        appTitleActions: bindActionCreators(appTitleActions, dispatch),
        userOperationsActions: bindActionCreators(userOperationsActions, dispatch),

    };
}

/**
 * @name - Editor Page
 * @description - Page for adding/editing/removing tags to assets
 */
@connect(mapStateToProps, mapDispatchToProps)
export default class EditorPage_Post_Process extends React.Component<IEditorPage_Post_ProcessProps, IEditorPage_Post_ProcessState> {
    public state: IEditorPage_Post_ProcessState = {
        selectedTag: null,
        lockedTags: [],
        assets: [],
        editorMode: EditorMode.Select,
        thumbnailSize: { width: 175, height: 155 },
        userId: null,
        project: null,
        tagsInfo: [],
        iseTagSelected: false,
        eTagSelectedId: "",
        eTagSelectedVal: "",
        newTagValue: "",
        editClicked:false


    };

    
    private renameCanceled: () => void;
   
    private selectedInvalidFile: any;
   
    TagsInfo=[]
    constructor(props) {
        super(props);
        this.selectedInvalidFile = JSON.parse(localStorage.getItem("selectedFileUrl"));
        console.log("this.selectedInvlidFle", this.selectedInvalidFile)

       
       
       
           }

    public async componentDidMount() {
        const user = this.props.loggedInUser;
        const userId = user.user.oid;

        
        this.setState({ userId });
        const projectname = "invoice_w_po_D";
        const connection = { id: null, name: null, providerType: "azureBlobStorage", providerOptions: {} };
        connection.providerOptions["sas"] = IAzureFields.sasUrl;
        document.title = strings.editorPage.title + " - " + strings.appName;
        axios( this.selectedInvalidFile['url_with_sas_json'] , { method: "GET"}).
        then((resp) => {
          if (resp.status === 200 || resp.status === 201) {
          
          

         
            let arrayList = Object.entries(resp.data['dcapResults'])
         arrayList.forEach(element=>{

            if(element[0]!== 'confidence'){
                if(element[0]!=='table'){
                    this.TagsInfo.push({
                        tagName:element[0],
                        tagValue:element[1],
                        isUpdated: false,
                        isEditClicked: false,
                    })
                }
            } 
         })
         this.setState({tagsInfo:this.TagsInfo}) 
          }

        })
        .catch((error) => {
        });

        // axios( this.selectedInvalidFile['url_with_sas_pdf'] , { method: "GET", headers}).
        // then((resp) => {
        //   if (resp.status === 200 || resp.status === 201) {
          
          

        //  console.log(resp,"@@@@@@@@@@@@@@@@@@@@@") 
        //   }

        // })
        // .catch((error) => {
        // });
        
  
    }



    

    public componentWillUnmount() {
        this.abortController.abort();
    }


    abortController = new window.AbortController();

    public render() {

        const project = this.state.project;
        const { assets, selectedAsset, tagsInfo } = this.state;
          return (

                <>
                    <HeaderComponent
                        history={this.props.history}
                        match={this.props.match}
                        location={this.props.location} />

                    <OperationsHeader propsMatch={this.props.match} />
                    <div className="editor-page skipToMainContent" id="pageEditor">

                        <BeforeUnloadComponent
                            alertMessage='Are you sure you want to leave? Changes will not be saved.'
                        >




                            <div className="editor-page-content">
                                <SplitPane split="vertical"
                                    primary="second"
                                    maxSize={500}
                                    minSize={500}
                                    pane1Style={{ height: "100%", width: "50%" }}
                                    pane2Style={{ height: "auto", width: "50%" }}
                                    resizerStyle={{ width: "5px", margin: "0px", border: "2px", background: "transparent" }}
                                   >
                                    <div className="editor-page-content-main" >

                                    <embed src="https://prdapifunction.blob.core.windows.net/dcap/1_time_form_tag-2541c8e9-3e3e-418a-9e21-818657238210/training/1time_form19.jpg?sv=2019-10-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2030-07-13T23:43:36Z&st=2020-07-13T15:43:36Z&spr=https&sig=wfqsJ4ekq78VnUG07q45YLKjBbTaZUB3S%2F%2BmppSlX1g%3D" width="500" height="100%" />
                                    
                                    </div>
                                    <div >

                                        {
                                            size(tagsInfo) !== 0 ?
                                                <div style={{}}>

                                                    {
                                                        this.tableDataShow()}
                                                </div>
                                                :
                                                <Spinner
                                                    size={SpinnerSize.small}
                                                    label="Loading Tags"
                                                    ariaLive="off"
                                                    labelPosition="bottom"
                                                />
                                        }
                                      
                                        
                                       
                                    </div>
                                </SplitPane>
                            </div>


                            
                        </BeforeUnloadComponent>
                    </div>

                </>
            );
        

    }


    public tableDataShow = () => {
        const { tagsInfo } = this.state;
        return (
            <div>
                {tagsInfo && size(tagsInfo) > 0 ?
                    <div className="card wrap-body-my_models shadow model-data mt-2">
                        <table className="table table-dark table-striped">
                            <thead>
                                <tr>
                                    <th>Tag Name</th>
                                    <th>Tag Value</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tagsInfo && tagsInfo.map((model, index) => {
                                    return (
                                        <>
                                            {model.isUpdated ?
                                                <tr key={index} className="UpdatedTag"  >
                                                    <td>{model.tagName}</td>
                                                    {model.isEditClicked ?
                                                        <td>
                                                            <input type="text" className="form-control" id="tag_val" name="tag_val"
                                                                onChange={this.getInputValues} value={this.state.newTagValue} />
                                                        </td> : <td >{model.tagValue}
                                                        </td>}
                                                    {model.isEditClicked ?
                                                        <td className="action-control">
                                                            <button role="button" className="view" onClick={() => this.saveTagData(model, index)}>
                                                                <i className="fa fa-save bg-color-1" aria-hidden="true"></i>
                                                            </button>
                                                            <button role="button" className="view" onClick={() => this.cancelTagData(model, index)}>
                                                                <i className="fa fa-window-close bg-color-1" aria-hidden="true"></i>
                                                            </button>
                                                        </td> :
                                                        <td className="action-control">
                                                            <button role="button" className="view" disabled={this.state.editClicked}
                                                                onClick={() => this.editTagData(model, index)}>
                                                                <i className="fa fa-edit bg-color-1" aria-hidden="true"></i>
                                                            </button>
                                                        </td>
                                                    }
                                                </tr>
                                                :
                                                <tr key={index}   >
                                                    <td>{model.tagName}</td>

                                                    {model.isEditClicked ?

                                                        <td>
                                                            <input type="text" className="form-control" id="tag_val" name="tag_val"
                                                                onChange={this.getInputValues} value={this.state.newTagValue} />
                                                        </td> :
                                                        <td >{model.tagValue}</td>
                                                    }
                                                    {model.isEditClicked ?
                                                        <td className="action-control">
                                                            <button role="button" className="view" onClick={() => this.saveTagData(model, index)}>
                                                                <i className="fa fa-save bg-color-1" aria-hidden="true"></i>
                                                            </button>
                                                            <button role="button" className="view" onClick={() => this.cancelTagData(model, index)}>
                                                                <i className="fa fa-window-close bg-color-1" aria-hidden="true"></i>
                                                            </button>
                                                        </td> :
                                                        <td className="action-control">
                                                            <button role="button" className="view" disabled={this.state.editClicked}
                                                                onClick={() => this.editTagData(model, index)}>
                                                                <i className="fa fa-edit bg-color-1" aria-hidden="true"></i>
                                                            </button>
                                                        </td>
                                                    }
                                                </tr>
                                            }
                                        </>

                                    );
                                })}
                            </tbody>
                        </table>
                        <div className="text-center mt-5">
                            <button

                                onClick={() => this.submitReviewData()}
                                className="btn-custom">
                                <i className="fa fa-code " aria-hidden="true"></i> Submit
                                            </button>
                        </div>

                    </div>
                    : <p className="text-center">No Data Available</p>}
            </div>
        );
    }

    private editTagData = async (data, index) => {
        this.setState({editClicked:true})
        const tagsInfo = [...this.state.tagsInfo];
        tagsInfo[index].isEditClicked = true;
        this.setState({ tagsInfo: tagsInfo, newTagValue: tagsInfo[index].tagValue });

    }



    private saveTagData = async (data, index) => {
        this.setState({editClicked:false})

        const tagsInfo = [...this.state.tagsInfo];
        tagsInfo[index].isUpdated = true;
        tagsInfo[index].isEditClicked = false;
        tagsInfo[index].tagValue = this.state.newTagValue;

        this.setState({ tagsInfo: tagsInfo, newTagValue: "" });

    }


    private cancelTagData = async (data, index) => {
        this.setState({editClicked:false})

        const tagsInfo = [...this.state.tagsInfo];
        tagsInfo[index].isUpdated = false;
        tagsInfo[index].isEditClicked = false;
        this.setState({ tagsInfo: tagsInfo });

    }

    private getInputValues = (event) => {

        if (event.target.value) {
            this.setState({ newTagValue: event.target.value });
        }
    }

    private submitReviewData = async () => {


        console.log(this.state.tagsInfo)

        let x

        let modified_output= this.TagsInfo['ddcapResults']
          this.state.tagsInfo.forEach(data=>{
            for(var i in modified_output){
                if(data.tagName==i){
                    modified_output[i] = data.tagValue;
                    break;
                } 
              }
          })

          console.log(modified_output)

          let body = {
            "modified_output":modified_output  
          }
        
        const endpointURL = postProcessingEditTags(this.selectedInvalidFile.path);
        axios( endpointURL , { method: "POST" , data: body, headers}).
        then((resp) => {
          if (resp.status === 200 || resp.status === 201) {


          }
        })
    }

}
